var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upOthers"},[_c('v-container',[_c('TitleAppBar',{attrs:{"title":'A propos',"menu":_vm.menu}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }